import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import ReactTooltip from 'react-tooltip';
import { Link } from 'react-router';
import Moment from 'moment';
import { linkTo } from 'helpers/url';
import { DISPLAY_DATE_TIME, RAILS_DATE_TIME } from 'config/constants';
import S from 'calendar.scss';

const isTraveling = (assignee, zip) => {
  const { covered_zip_codes, traveling_zip_codes } = assignee;
  return !covered_zip_codes.includes(zip) && traveling_zip_codes.includes(zip);
};

const CalendarAssigneeInfo = ({
  assignee, role, showProjectedTime, projectedJobDays, onOpeningClick, showIfTraveling,
  projectedJobLength, projectedCompletion, nextOpening, selectedAssignee, phaseZip,
}) => <div className={S.assigneeInfo}>
  <div className={S.assigneeDetails}>
    <span className={S.assigneeText}>
      <Link
        className={S.assigneeLink}
        to={linkTo(assignee)}
        target="_blank"
        data-tip={assignee.notes || 'No Notes'}
        data-for={`assignee${assignee.kind + assignee.id}`}
      >
        {assignee.name} ({assignee.kind})
      </Link>
      {(assignee.delivery_dedicated || false) && (<span className={S.notice}>
        DELIVERY DEDICATED
      </span>)}
      {!assignee.delivery_dedicated && showIfTraveling && isTraveling(assignee, phaseZip) &&
        <span className={S.notice}>TRAVELING CREW</span>}
      {showProjectedTime && !(assignee.specificMismatch) && <Fragment>
        <br /><br />
        Time Needed: {projectedJobLength} hours ({projectedJobDays} day{projectedJobLength > 1 ? 's' : ''})
        {selectedAssignee && <Fragment>
          <br />
          Est. Complete: {
            (
              Moment(projectedCompletion, [DISPLAY_DATE_TIME, RAILS_DATE_TIME], true).isValid()
                ? Moment(projectedCompletion, [DISPLAY_DATE_TIME, RAILS_DATE_TIME], true)
                : Moment(projectedCompletion, Moment.ISO_8601, true)
            ).format(DISPLAY_DATE_TIME)
          }
          <br />
          <option
            className={S.assigneeLink}
            onClick={onOpeningClick}
          >Next Opening: {nextOpening}</option>
        </Fragment>}
      </Fragment>}
      {role !== 'installer' && <ReactTooltip
        id={`assignee${assignee.kind + assignee.id}`}
        className={S.tooltip}
        multiline place="top"
        effect="solid"
      />}
    </span>
  </div>
</div>;

CalendarAssigneeInfo.propTypes = {
  selectedAssignee: PropTypes.object,
  assignee: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.oneOf(['estimator', 'installer', 'employee']),
  }).isRequired,
  showProjectedTime: PropTypes.bool,
  showIfTraveling: PropTypes.bool,
  projectedJobDays: PropTypes.number,
  projectedJobLength: PropTypes.number,
  projectedCompletion: PropTypes.string,
  nextOpening: PropTypes.string,
  role: PropTypes.string,
  onOpeningClick: PropTypes.func,
  phaseZip: PropTypes.string,
};

CalendarAssigneeInfo.defaultProps = {
  selectedAssignee: null,
  showProjectedTime: false,
  onOpeningClick: () => {},
};

export default CalendarAssigneeInfo;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/calendarAssigneeInfo.jsx